const GENERIC_ERROR = 'We could not load the data required to display this page. Please try again in a moment. If the issue persists, please contact Modalyst support.'

export const Messages = {
  error: {
    title: 'We could not complete your request',
    generic: GENERIC_ERROR,
  }
}

const root = 'ManagePlanPage'

export const TestId = {
  root,
  title: `${root}-title`,
}
